import { render, staticRenderFns } from "./StatusPill.vue?vue&type=template&id=79e8e443&"
import script from "./StatusPill.vue?vue&type=script&lang=js&"
export * from "./StatusPill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports